import { captureException } from '@sentry/react';

import {
  DETECTION_EDGE,
  DETECTION_STAGE,
} from '~/modules/tools/views/AiDetectorV4/constants';

import { AIDetectorLoadingService } from './services/LoadingService/AIDetectorLoadingService';
import { AIDetectorLoadingServicesMap } from './services/LoadingService/constants';
import { AIDetectorVariation } from './services/LoadingService/types';

export const getDetectionStage = (result: number): DETECTION_STAGE => {
  const stage = Object.entries(DETECTION_EDGE)
    .sort(([, a], [, b]) => b - a)
    .find(([, value]) => result >= value);
  return stage ? (stage[0] as DETECTION_STAGE) : DETECTION_STAGE.FULLY_HUMAN;
};

export const getTextSpecialSymbols = (text: string): string[] => {
  const regexp = /[*#]/g;
  const matches = text.match(regexp);

  if (!matches) {
    return [];
  }

  return [...new Set(matches)];
};

export const getDetectorWordsBalance = (): number => {
  const BALANCE = {
    standard: 80000,
  };

  return BALANCE.standard;
};

export const getDetectorInputLimits = (data: {
  isNotPremium: boolean;
}): { minCount: number; maxCount: number } => {
  const LIMITS = {
    standard_min: 50,
    standard_max: 50000,
    not_premium_max: 25000,
  };

  return {
    minCount: LIMITS.standard_min,
    maxCount: data.isNotPremium ? LIMITS.not_premium_max : LIMITS.standard_max,
  };
};

export const getAIDetectorLoadingTimeService = (
  variationFromBackend: unknown,
): AIDetectorLoadingService => {
  const aiDetectorVariation: AIDetectorVariation | undefined = [
    'control',
    'test',
  ].includes(variationFromBackend as string)
    ? (variationFromBackend as AIDetectorVariation)
    : undefined;

  if (!aiDetectorVariation) {
    captureException(new Error('Invalid AI detector variation'), {
      extra: {
        variation: variationFromBackend,
      },
      tags: {
        function: 'getAIDetectorLoadingTimeService',
      },
    });
    return AIDetectorLoadingServicesMap.control;
  }

  return AIDetectorLoadingServicesMap[aiDetectorVariation];
};
